import React, { useState, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import AugtyroDesignationForm from "./AugtyroDesignationForm";
import CamzyosDesignationForm from "./CamzyosDesignationForm";
import ImidDesignationForm from "./ImidDesignationForm";
import KrazatiDesignationForm from "./KrazatiDesignationForm";
import ZenbexusDesignationForm from "./ZenbexusDesignationForm";
import Bms from "~/images/BMS.png";

const BmsDesignations = ({ entities, setCompletedDesignations }) => {
  const manufacturer = "bristol_myers_squibb";
  const manufacturerName = "Bristol Myers Squibb";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({ [manufacturer]: {} });

  useEffect(() => {
    const openForms = _.flatMap(manufacturerFormDetails[manufacturer], (form) =>
      form.open ? [form] : []
    );
    setCompletedDesignations(_.every(openForms, ["completed", true]));
  }, [manufacturerFormDetails]);

  const sharedProps = {
    entities,
    manufacturer,
    manufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      specialtyKeyName={specialtyKeyName}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
    />
  );

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Bms} alt={`${manufacturerName} logo`} />
        </div>
        <div className="designation_form__section__header__title">{manufacturerName}</div>
      </div>
      {renderDesignationForm(ImidDesignationForm, "rems")}
      <RetailDesignationForm
        {...sharedProps}
        kind="retail"
        setRetailSelectedSpecialtyPharmacy={setRetailSelectedSpecialtyPharmacy}
        setRetailHasSelectedSpecialtyPharmacy={setRetailHasSelectedSpecialtyPharmacy}
      />
      {renderDesignationForm(CamzyosDesignationForm, "camzyos")}
      {renderDesignationForm(KrazatiDesignationForm, "krazati")}
      {renderDesignationForm(AugtyroDesignationForm, "augtyro")}
      {renderDesignationForm(ZenbexusDesignationForm, "zenbexus")}
    </div>
  );
};

export default BmsDesignations;
